import { Environment } from '../environmentService'
import { RootState } from '../rootReducer'

export default {
  getAngularBaseUrl: (state: RootState): string => state.environment.angularBaseUrl,
  getBaseUrl: (state: RootState): string => state.environment.baseUrl,
  getEnvironment: (state: RootState): Environment => state.environment.environment
}
